module.exports = __webpack_public_path__ + "static/media/2.6310ce9b.png";